import { ButtonMenu } from ".";
import { BriefCase, Rupiah } from "../icons";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import FrameFindUsTop from "../../assets/images/frame-find-us-top.png";

const SolutionDailyBadgeWrapper = styled.div`
  height: max-content;
  padding: 24px 16px 0 16px;
  position: relative;

  @media (max-width: 576px) {
    margin-top: 40px;
  }
`;


const Header = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  color: #776E64;

  .icon{
    width: 16px;
    height: 16px;
  }

  .title{
    margin-left: 6px;
  }
`;

const Content = styled.div`
  .row{
    padding: 0;
  }

  @media (max-width: 576px) {
    font-size: 0.8em;
  }
`;

const Frame = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  width: 240px;
  height: 162px;
  width: auto;

  @media (max-width: 576px) {
    display: none;
`;

const SolutionBusinessBadge = () => {
  const { t } = useTranslation();

  const movePage = (path) => {
    window.open(path);
  };

  const routingPage = (path) =>{
    window.location.href = path;
  }
  return (
    <SolutionDailyBadgeWrapper>
      <Frame src={FrameFindUsTop} />
      <Header>
        <div className="col-8 d-flex justify-content-start align-items-stretch">
          <BriefCase fill="#85714d" className="icon"/>
          <div className="title color-brown">{t("your_business_solution")}</div>
        </div>
      </Header>
      <Content className="row m-1 position-relative">
        <Row>
          <Col xs="4" onClick={() => routingPage("/business-solution/umkm")}>
            <ButtonMenu label={t("umkm")} icon={BriefCase}/>
          </Col>
          <Col xs="4" onClick={() => routingPage("/business-solution/komersial")}>
            <ButtonMenu label={t("comercial")} icon={Rupiah} />
          </Col>
        </Row>
      </Content>
    </SolutionDailyBadgeWrapper>
  );
};

export default SolutionBusinessBadge;
